/* Visor de fotos de reseñas F&NT (18 oct 2026, v30).
   Al tocar una miniatura de .fnt-rv__photos, la foto se abre dentro de la página (antes abría
   el archivo de Klaviyo en otra pestaña). Nombre, estrellas y texto se leen de la reseña que
   arma assets/fnt-resenas.js. Varias fotos en una reseña: flechas, teclado o deslizar.
   Sin <dialog> en el navegador, el enlace sigue funcionando como antes. Estilos: fnt-resenas.css. */
(function () {
  if (window.fntRvLightbox || typeof HTMLDialogElement !== 'function') return;
  window.fntRvLightbox = true;

  var MEDIA = 'https://klaviyo.s3.amazonaws.com/reviews/images/';
  var BIG = 'https://reviews-media.services.klaviyo.com/abc/width:1200/plain/';
  var dlg, img, cap, count, prev, next, lastFocus;
  var group = [];
  var index = 0;
  var startX = null;
  var startY = null;

  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'fnt-lb';
    dlg.setAttribute('aria-label', 'Foto de la reseña');
    dlg.innerHTML =
      '<button type="button" class="fnt-lb__btn fnt-lb__close" aria-label="Cerrar">✕</button>' +
      '<span class="fnt-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="fnt-lb__btn fnt-lb__prev" aria-label="Foto anterior">‹</button>' +
      '<figure class="fnt-lb__fig"><img class="fnt-lb__img" alt=""><figcaption class="fnt-lb__cap"></figcaption></figure>' +
      '<button type="button" class="fnt-lb__btn fnt-lb__next" aria-label="Foto siguiente">›</button>';
    document.body.appendChild(dlg);

    img = dlg.querySelector('.fnt-lb__img');
    cap = dlg.querySelector('.fnt-lb__cap');
    count = dlg.querySelector('.fnt-lb__count');
    prev = dlg.querySelector('.fnt-lb__prev');
    next = dlg.querySelector('.fnt-lb__next');

    img.addEventListener('load', function () { img.classList.add('is-loaded'); });
    // Si la versión reducida falla, se usa la foto original
    img.addEventListener('error', function () {
      var full = img.dataset.full;
      if (full && img.src !== full) img.src = full;
    });

    dlg.querySelector('.fnt-lb__close').addEventListener('click', function () { dlg.close(); });
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    // Tocar fuera de la foto cierra
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.classList.contains('fnt-lb__fig')) dlg.close();
    });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });

    dlg.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    dlg.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    });

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('fnt-lb-open');
      img.removeAttribute('src');
      img.classList.remove('is-loaded');
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    });
  }

  // Datos de la reseña a la que pertenece la foto
  function caption(link) {
    var box = link.closest('.fnt-rv__item, .fnt-rv__featured');
    if (!box) return '';
    var nameEl = box.querySelector('.fnt-rv__name');
    var starsEl = box.querySelector('.fnt-rv__item-stars');
    var textEl = box.querySelector('.fnt-rv__text, .fnt-rv__featured-quote');
    var stars = starsEl ? parseInt(starsEl.getAttribute('aria-label'), 10) || 0 : 0;
    var text = textEl ? textEl.textContent.replace(/^[“"]|[”"]$/g, '').trim() : '';
    var starsHtml = '';
    for (var i = 1; i <= 5; i++) starsHtml += i <= stars ? '★' : '☆';

    return '<span class="fnt-lb__cap-top">' +
        (stars ? '<span class="fnt-lb__stars" aria-label="' + stars + ' de 5 estrellas">' + starsHtml + '</span>' : '') +
        (nameEl ? '<strong class="fnt-lb__name">' + esc(nameEl.textContent) + '</strong>' : '') +
        '<span class="fnt-lb__badge">✔ Compra verificada</span>' +
      '</span>' +
      (text ? '<span class="fnt-lb__text">' + esc(text) + '</span>' : '');
  }

  function show() {
    var link = group[index];
    var full = link.href;
    var thumb = link.querySelector('img');
    img.classList.remove('is-loaded');
    img.dataset.full = full;
    img.alt = thumb ? thumb.alt : '';
    img.src = full.indexOf(MEDIA) === 0 ? BIG + full : full;
    var many = group.length > 1;
    count.textContent = many ? (index + 1) + ' / ' + group.length : '';
    prev.hidden = !many;
    next.hidden = !many;
  }

  function go(step) {
    if (group.length < 2) return;
    index = (index + step + group.length) % group.length;
    show();
  }

  function open(link) {
    if (!dlg) build();
    group = Array.prototype.slice.call(link.parentNode.querySelectorAll('a'));
    index = Math.max(0, group.indexOf(link));
    lastFocus = link;
    cap.innerHTML = caption(link);
    show();
    document.documentElement.classList.add('fnt-lb-open');
    dlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.fnt-rv__photos a');
    if (!link) return;
    // Cmd/Ctrl+clic sigue abriendo la foto en otra pestaña
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open(link);
  });
})();
